import React, { useEffect, useState } from "react";
import {
  Breadcrumbs,
  Button,
  Modal,
  Select,
} from "../../../../../components/core";
import { ContentContainer } from "../../../../../components/layout";
import DropoffCostTable from "../partner-fees/dropoff-cost-table";
import { useDispatch, useSelector } from "react-redux";
import {
  ADD_PARTNER_DROPOFF_FEE,
  ADD_PARTNER_SHIPOUT_FEE,
  LOCKER_RELATED_PARTNER_TYPE_LIST,
  LOCKER_TYPES,
} from "../../../../../constants/graphql/locker-queries";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  handelCancelChagesReducer,
  handleAddDropoffCostItemReducer,
  handleAddPackageShipoutCostItemReducer,
  handleChangeLockerTypeAndPartnerTypeReducer,
  handleEditAddedDropoffCostItemReducer,
  handleEditAddedPackageShipoutCostItemReducer,
  setLockerTypeList,
  setPartnerTypeList,
} from "../../../../../features/locker-fees/add-partner-fees/add-partner-fees-slice";
import PackageShipoutCostTable from "../partner-fees/package-shipout-cost-table";
import { useNavigate, useParams } from "react-router-dom";
import { Strings } from "../../../../../constants/strings";
import useSidebarStore from "../../../../../zustand/stores/sidebar-store";
import {
  ALL_PARTNER_CAREGORIES,
  PARTNER_TYPE,
} from "../../../../../constants/graphql/partner-types-query";
import { set } from "react-hook-form";
import { Divider } from "primereact/divider";
import {
  PARTNER_CATEGORY,
  PARTNER_TYPE_FOR_PARTNER,
} from "../../../../../constants/graphql/partners-query";
import { BlockUI } from "primereact/blockui";
import { LOCKER_TIME_LIMIT } from "../../../../../constants/graphql/locker-time-limits-query";
const breadcrumbItems = [
  {
    label: "Locker Fees",
    path: `/locker-fees/`,
  },
  { label: "Add Partner Fee", path: "#" },
];
export default function AddPartnerFees() {
  const dispatch = useDispatch();
  const url = window.location.href;

  const operatorId = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user")).operator_id
    : "";

  // const partnerTypesParams = JSON.parse(
  // 	decodeURIComponent(url.split("/")[url.split("/").length - 2])
  // );
  const lockerTypeId = url.split("/")[url.split("/").length - 1];
  // const { partnerTypesParams } = useParams();
  const [partnerCategoryOpt, setPartnerCategoryOptions] = useState([]);
  const [partnerTypeList, setPartnerTypeList] = useState([]);
  const [finalPartnerTypeList, setFinalPartnerTypeList] = useState([]);
  const [partnerTypesItems, setPartnerTypesItems] = useState([]);
  const [partnerCategoryItems, setPartnerCategoryItems] = React.useState([]);
  const [lockerTimeLimit, { data: lockerLimit, refetch }] = useLazyQuery(
    LOCKER_TIME_LIMIT,
    {
      fetchPolicy: "no-cache",
    }
  );

  const navigate = useNavigate();
  // Selectors
  const addDropoffCostItem = useSelector(
    (state) => state.addPartnerFee.addDropoffCostItem
  );
  const addPackageShipoutCostItem = useSelector(
    (state) => state.addPartnerFee.addPackageShipoutCostItem
  );
  const lockerTypesList = useSelector(
    (state) => state.addPartnerFee.lockerTypesList
  );
  // const partnerTypesList = useSelector(
  // 	(state) => state.addPartnerFee.partnerTypesList
  // );
  const lockerTypeAndPartnerType = useSelector(
    (state) => state.addPartnerFee.lockerTypeAndPartnerType
  );

  console.log({ lockerTypeAndPartnerType });

  // zustand
  const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
  const setPendingNavigation = useSidebarStore(
    (state) => state.setPendingNavigation
  );
  const activeSubItem = useSidebarStore((state) => state.activeSubItem);
  const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);

  //Graphql
  const lockerTypes = useQuery(LOCKER_TYPES, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });
  const partnerTypes = useQuery(PARTNER_TYPE_FOR_PARTNER, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      partnerCategoryNo:
        lockerTypeAndPartnerType.partnerCategoryNo !== "-1"
          ? lockerTypeAndPartnerType.partnerCategoryNo
          : "",
    },
  });

  const partnerCategories = useQuery(PARTNER_CATEGORY);

  useEffect(() => {
    if (partnerCategories.data) {
      var tempArr = [];
      partnerCategories.data.partnerCategories.forEach((element) => {
        tempArr.push({
          value: element.partnerCategoryNo,
          name: element.partnerCategory,
        });
      });
      setPartnerCategoryItems(tempArr);
    }
  }, [partnerCategories.data]);

  // useEffect(() => {
  //   if (lockerTypeAndPartnerType.partnerCategoryNo) {
  //     partnerTypes({
  //       variables: {
  //         operatorId: localStorage.getItem("user")
  //           ? JSON.parse(localStorage.getItem("user")).operator_id
  //           : "",
  //         lockerTypeIds: [lockerTypeId],
  //         partnerCategoryNo: lockerTypeAndPartnerType.partnerCategoryNo,
  //       },
  //     }).then((data) => {
  //       if (data.data) {
  //         setPartnerTypeList(data.data);
  //       }
  //     });
  //     dispatch(
  //       handleChangeLockerTypeAndPartnerTypeReducer({
  //         name: "partnerTypeId",
  //         value: "-1",
  //       })
  //     );
  //   }
  // }, [lockerTypeAndPartnerType.partnerCategoryNo]);

  useEffect(() => {
    if (partnerTypeList && partnerTypeList.partnerTypes?.length > 0) {
      const map = partnerTypeList.partnerTypes
        .filter(
          (category) =>
            !(
              category.partnerDropoffFees?.length > 0 ||
              category.partnerShipoutFees?.length > 0
            )
        )
        .map((category) => ({
          value: category.partnerTypeId,
          name: category.partnerType,
          pickupPulloutLimit:
            category.lockerPartnerLimits.length > 0
              ? category.lockerPartnerLimits.pickupPulloutLimit
              : null,
        }));

      setFinalPartnerTypeList(map);
    }
  }, [partnerTypeList.partnerTypes]);

  console.log({ partnerTypeList });

  // Local states
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    open: false,
  });
  const [confirmValidation, setConfirmValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    open: false,
  });
  const [changesMade, setChangesMade] = useState(false);
  const [addPartnerDropoffFee] = useMutation(ADD_PARTNER_DROPOFF_FEE);
  const [addPartnerShipoutFee] = useMutation(ADD_PARTNER_SHIPOUT_FEE);
  // ---- Handle Events ------/
  const handleOnChangeLockerTypeAndPartnerType = (event) => {
    const { name, value } = event.target;

    // If partner type is being selected, find and save its pickupPulloutLimit
    let pickupPulloutLimit = undefined;
    if (name === "partnerTypeId" && value !== "-1") {
      const selectedPartner = partnerTypesItems.find(
        (item) => item.value === value
      );
      pickupPulloutLimit = selectedPartner?.pickupPulloutLimit ?? null;
    }

    dispatch(
      handleChangeLockerTypeAndPartnerTypeReducer({
        name,
        value,
        pickupPulloutLimit,
      })
    );
  };
  // For Dropoff Cost
  const handleAddDropoffCostItem = () => {
    dispatch(
      handleAddDropoffCostItemReducer({
        operatorId: localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).operator_id
          : "",
        lockerTypeId: lockerTypeId,
        partnerTypeId: lockerTypeAndPartnerType.partnerTypeId,
        doorSizeId: "1",
        dropoffFee: "",
        initialFreeHours: "",
        rtsFee: "",
        rtsOverstayMaxFee: "",
        rtsOverstayRate: "",
        rtsOverstayUnitHours: "",
      })
    );
    setChangesMade(true);
  };
  const handleEditAddedDropoffCostItem = (event) => {
    const { name, value, id } = event.target;
    dispatch(
      handleEditAddedDropoffCostItemReducer({
        name: name,
        value: value,
        id: id,
      })
    );
    setChangesMade(true);
  };

  useEffect(() => {
    // console.log("Effect triggered:", {
    // 	pendingNavigationHere,
    // 	changesMade,
    // 	currentPath: location.pathname,
    // });
    if (pendingNavigation !== null) {
      if (changesMade) {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: `${Strings.popup_confirm_cancel_title}?`,
          message: Strings.popup_confirm_cancel_massage,
          open: true,
          actions: (
            <div className="flex justify-between gap-3">
              <Button
                onClick={() => {
                  setValidation({ open: false });
                  // window.location.reload();
                  setPendingNavigation(null);
                  setActiveSubItem(activeSubItem);
                }}
                value={"No"}
                className={"p-2 w-full"}
              />
              <Button
                onClick={() => {
                  navigate(pendingNavigation);
                  setPendingNavigation(null);
                }}
                value={"Yes"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
      } else {
        navigate(pendingNavigation);
        setPendingNavigation(null);
      }
    }
  }, [pendingNavigation, changesMade]);

  // For Package Shipout Cost
  const handleAddPackageShipoutCostItem = () => {
    dispatch(
      handleAddPackageShipoutCostItemReducer({
        operatorId: localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).operator_id
          : "",
        lockerTypeId: lockerTypeId,
        partnerTypeId: lockerTypeAndPartnerType.partnerTypeId,
        doorSizeId: "1",
        commissionPercent: "",
        initialShipoutFee: "",
        initialFreeHours: "",
        excessFeePerInc: "",
        incByHours: "",
        maxOverstayCharge: "",
      })
    );
    setChangesMade(true);
  };
  const handleEditAddedPackageShipoutCostItem = (event) => {
    const { name, value, id } = event.target;
    dispatch(
      handleEditAddedPackageShipoutCostItemReducer({
        name: name,
        value: value,
        id: id,
      })
    );
    setChangesMade(true);
  };

  const handleSaveChanges = async () => {
    // Early validation for partner type
    if (lockerTypeAndPartnerType.partnerTypeId === "-1") {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Incomplete Search Criteria",
        message: "Please select Partner Type.",
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => {
                setValidation({ open: false });
              }}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      return;
    }

    // Validate empty fields
    const hasEmptyDropoffFields = addDropoffCostItem.some(
      (x) =>
        x.doorSizeId === "" || x.dropoffFee === "" || x.initialFreeHours === ""
    );

    const hasEmptyShipoutFields = addPackageShipoutCostItem.some(
      (x) =>
        x.doorSizeId === "" ||
        x.commissionPercent === "" ||
        x.initialShipoutFee === "" ||
        x.initialFreeHours === "" ||
        x.excessFeePerInc === "" ||
        x.incByHours === "" ||
        x.maxOverstayCharge === ""
    );

    if (hasEmptyDropoffFields || hasEmptyShipoutFields) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Form Error",
        message: "All fields are required.",
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => {
                setValidation({ open: false });
              }}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      return;
    }

    // Validate duplicate door sizes
    const hasDuplicateDropoffDoors = addDropoffCostItem.some(
      (item, index, self) =>
        self.findIndex((t) => t.doorSizeId === item.doorSizeId) !== index
    );

    const hasDuplicateShipoutDoors = addPackageShipoutCostItem.some(
      (item, index, self) =>
        self.findIndex((t) => t.doorSizeId === item.doorSizeId) !== index
    );

    if (hasDuplicateDropoffDoors || hasDuplicateShipoutDoors) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: Strings.popup_error_title_duplicate,
        message: "There is duplicate door size in your entry.",
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => {
                setValidation({ open: false });
              }}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      return;
    }

    try {
      // Execute all dropoff fee mutations
      const dropoffPromises = addDropoffCostItem.map((element) => {
        const formattedElement = {
          operatorId: parseInt(element.operatorId),
          partnerTypeId: parseInt(element.partnerTypeId),
          lockerTypeId: parseInt(element.lockerTypeId),
          doorSizeId: parseInt(element.doorSizeId),
          initialFreeHours: parseInt(element.initialFreeHours),
          dropoffFee: parseFloat(element.dropoffFee),
          rtsFee: parseFloat(element.rtsFee),
          rtsOverstayRate: parseFloat(element.rtsOverstayRate),
          rtsOverstayUnitHours: parseInt(element.rtsOverstayUnitHours),
          rtsOverstayMaxFee: parseFloat(element.rtsOverstayMaxFee),
        };

        return addPartnerDropoffFee({ variables: formattedElement });
      });

      // Execute all shipout fee mutations with adjusted commission
      const shipoutPromises = addPackageShipoutCostItem.map((element) => {
        const tempElement = {
          ...element,
          commissionPercent: element.commissionPercent / 100,
        };
        return addPartnerShipoutFee({ variables: tempElement });
      });

      // Wait for all mutations to complete
      await Promise.all([...dropoffPromises, ...shipoutPromises]);

      // Show success validation
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
        title: Strings.popup_success_title_default,
        message: Strings.popup_success_message_add,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => {
                navigate(
                  `/locker-fees/edit-partner-fees/${lockerTypeId}/${lockerTypeAndPartnerType?.partnerTypeId}`
                );
              }}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
    } catch (error) {
      console.error("Error saving changes:", error);
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Error",
        message: "Failed to save changes. Please try again.",
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => {
                setValidation({ open: false });
              }}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
    }
  };
  const handleCancelChanges = () => {
    navigate(`/locker-fees/`);
    dispatch(handelCancelChagesReducer());
  };
  // Use Effects
  useEffect(() => {
    if (partnerTypes.data) {
      let tempVar = [];

      partnerTypes.data.partnerTypes.forEach((element) => {
        // if (
        // 	!partnerTypesParams.find(
        // 		(x) => x.partnerTypeId == element.partnerTypeId
        // 	)
        // ) {
        tempVar.push({
          value: element.partnerTypeId,
          name: element.partnerType,
        });
        // }
      });

      setPartnerTypeList(tempVar);

      // dispatch(setPartnerTypeList(tempVar));
    }
  }, [partnerTypes.data]);

  useEffect(() => {
    if (partnerTypes.data) {
      // searchPartner.data.searchCouriers[0].partnerType.partnerCategory.partnerCategory
      var tempArr = [];
      partnerTypes.data.partnerTypes.forEach((element) => {
        tempArr.push({
          value: element.partnerTypeId,
          name: element.partnerType,
          pickupPulloutLimit:
            element.lockerPartnerLimits.length > 0
              ? element.lockerPartnerLimits[0].pickupPulloutLimit
              : null,
        });
      });
      setPartnerTypesItems(tempArr);
    }
  }, [partnerTypes.data]);
  React.useEffect(() => {
    if (lockerTypes.data) {
      let tempVar = [];
      lockerTypes.data.lockerTypes.forEach((element) => {
        tempVar.push({
          value: element.lockerTypeId,
          name: element.lockerType,
        });
      });
      dispatch(setLockerTypeList(tempVar));
    }
  }, [lockerTypes.data]);

  const [partnerTypeLimits, setPartnerTypeLimits] = useState(null);

  useEffect(() => {
    if (lockerTypeAndPartnerType.partnerTypeId !== "-1") {
      lockerTimeLimit({
        variables: {
          operatorId: operatorId,
          lockerTypeId: lockerTypeId,
          partnerTypeId: lockerTypeAndPartnerType.partnerTypeId,
        },
      });
    }
  }, [lockerTypeAndPartnerType.partnerTypeId, operatorId, lockerTypeId]);

  useEffect(() => {
    if (lockerLimit && lockerLimit?.lockerPartnerLimits.length > 0) {
      setPartnerTypeLimits(lockerLimit?.lockerPartnerLimits[0]);
    } else {
      setPartnerTypeLimits([]);
    }
  }, [lockerLimit]);

  return (
    <>
      <Breadcrumbs items={breadcrumbItems} />
      <ContentContainer containerTitle={"Locker Fees"}>
        <div className="pb-6 grid grid-cols-12 items-center space-y-2">
          <>
            <p className="col-span-2">Locker Type:</p>
            <p className="col-span-10 font-bold">
              {lockerTypesList.find((x) => x.value === lockerTypeId) &&
                lockerTypesList.find((x) => x.value === lockerTypeId).name}
            </p>
          </>

          <>
            <p className="col-span-2">Partner Category</p>
            <Select
              className={`col-span-4`}
              items={partnerCategoryItems}
              value={lockerTypeAndPartnerType?.partnerCategoryNo}
              name="partnerCategoryNo"
              onChange={handleOnChangeLockerTypeAndPartnerType}
              defaultOption={{
                value: "-1",
                name: "-- Select Partner Category --",
              }}
            />
            <div className="col-span-6"></div>
          </>

          <>
            <p className="col-span-2">Partner Type:</p>
            <Select
              className={`col-span-4`}
              items={partnerTypesItems}
              disabled={lockerTypeAndPartnerType.partnerCategoryNo === "-1"}
              value={lockerTypeAndPartnerType.partnerTypeId}
              name="partnerTypeId"
              onChange={handleOnChangeLockerTypeAndPartnerType}
              defaultOption={{ value: "-1", name: "-- Select Partner Type --" }}
            />
          </>
        </div>

        {/* Here are the tables */}
        {lockerTypeAndPartnerType.partnerTypeId !== "-1" && (
          <>
            {/* <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-6 rounded-r">
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <svg
                    className="h-5 w-5 text-blue-500 mt-0.5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div className="ml-3">
                  <p className="text-sm font-semibold text-blue-900 mb-1">
                    Pullout Limit: {lockerTypeAndPartnerType.pickupPulloutLimit}{" "}
                    hours
                  </p>
                  <p className="text-sm text-blue-800">
                    Maximum time allowed for courier to respond to take-back
                    package alerts before a pullout alert is sent. RTS fees
                    apply after this period.
                  </p>
                </div>
              </div>
            </div> */}

            <DropoffCostTable
              pulloutHours={
                partnerTypeLimits?.pickupPulloutLimit !== null
                  ? partnerTypeLimits?.pickupPulloutLimit
                  : 0
              }
              lockerType={
                lockerTypesList.find(
                  (x) => x.value === lockerTypeAndPartnerType.lockerTypeId
                )
                  ? lockerTypesList.find(
                      (x) => x.value === lockerTypeAndPartnerType.lockerTypeId
                    ).name
                  : ""
              }
              partnerType={
                finalPartnerTypeList.find(
                  (x) => x.value === lockerTypeAndPartnerType.partnerTypeId
                )
                  ? finalPartnerTypeList.find(
                      (x) => x.value === lockerTypeAndPartnerType.partnerTypeId
                    ).name
                  : ""
              }
              handleAddDataItem={handleAddDropoffCostItem}
              handleModifyAddedItems={handleEditAddedDropoffCostItem}
              addedData={addDropoffCostItem}
            />

            <div className="w-full px-9">
              <Divider className=" border border-gray-200 px-11"></Divider>
            </div>

            <PackageShipoutCostTable
              lockerType={
                lockerTypesList.find(
                  (x) => x.value === lockerTypeAndPartnerType.lockerTypeId
                )
                  ? lockerTypesList.find(
                      (x) => x.value === lockerTypeAndPartnerType.lockerTypeId
                    ).name
                  : ""
              }
              partnerType={
                finalPartnerTypeList.find(
                  (x) => x.value === lockerTypeAndPartnerType.partnerTypeId
                )
                  ? finalPartnerTypeList.find(
                      (x) => x.value === lockerTypeAndPartnerType.partnerTypeId
                    ).name
                  : ""
              }
              addedData={addPackageShipoutCostItem}
              handleAddDataItem={handleAddPackageShipoutCostItem}
              handleModifyAddedItems={handleEditAddedPackageShipoutCostItem}
            />

            <div className="w-full flex justify-center">
              {changesMade && (
                <div className="grid grid-cols-2 gap-2 w-1/4 pt-5 justify-center">
                  <Button
                    value={"Cancel Changes"}
                    className={
                      "p-2 bg-white border border-primary-primaryYellow"
                    }
                    onClick={() => {
                      setConfirmValidation({
                        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                        title: "Cancel Changes",
                        message: "Are you sure you want to cancel changes?",
                        open: true,
                        event: handleCancelChanges,
                      });
                    }}
                  />
                  <Button
                    value={"Save Changes"}
                    className={"p-2"}
                    onClick={() => {
                      setConfirmValidation({
                        icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
                        title: "Save Changes",
                        message: "Are you sure you want to save changes?",
                        open: true,
                        event: handleSaveChanges,
                      });
                    }}
                  />
                </div>
              )}
            </div>
          </>
        )}

        <Modal
          icon={validation.icon}
          title={validation.title}
          message={validation.message}
          open={validation.open}
          actions={validation.actions}
        />
        {/* <div className="grid grid-cols-1 gap-2">
					<Button
						onClick={() => {
							setValidation((prev) => ({
								...prev,
								open: false,
							}));
						}}
						value={"OK"}
						className={"p-2"}
					/>
				</div> */}
        <Modal
          icon={confirmValidation.icon}
          title={confirmValidation.title}
          message={confirmValidation.message}
          open={confirmValidation.open}
          actions={
            <div className="grid grid-cols-2 gap-2">
              <Button
                onClick={() => {
                  setConfirmValidation((prev) => ({
                    ...prev,
                    open: false,
                  }));
                }}
                value={"No"}
                className={"p-2"}
              />
              <Button
                onClick={() => {
                  setConfirmValidation((prev) => ({
                    ...prev,
                    open: false,
                  }));
                  confirmValidation.event();
                }}
                value={"Yes"}
                className={"p-2"}
              />
            </div>
          }
        />
      </ContentContainer>
    </>
  );
}
